import React, { FC } from 'react'
import loading from '../../assets/img/loading.gif'
import { IProps } from './types'

const Loading: FC<IProps> = ({ text }) => {
  return (
    <div className="w-full">
      <img
        src={loading}
        className="w-10 m-auto block py-6 text-center"
        alt="Loading..."
      />
      {text && <p className="has-text-centered mt-4">{text}</p>}
    </div>
  )
}

export default Loading
